var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeedbackBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1168,
    height: 381,
    viewBox: "0 0 1168 381",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter0_f_479_10623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-103 265C-305.567 274.455 -213.707 577.148 116 510.5L643.5 295.987L924.547 295.987L1319.44 351.989L1273.05 225.541L1228 23.5001L1174.48 -133.923C1188.09 -83.1125 898.66 76.1913 583 169.5C338.785 241.69 86.8981 256.137 -103 265Z",
    fill: "url(#paint0_diamond_479_10623)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_479_10623",
    x: -309.951,
    y: -233.923,
    width: 1729.39,
    height: 854,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_479_10623"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_diamond_479_10623",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(538.719 252.197) rotate(78.5722) scale(252.5 745.469)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29156C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E359EF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackBg);
export default __webpack_public_path__ + "static/media/feedback_bg.8bbc2e7a089e0a911056d761717b0998.svg";
export { ForwardRef as ReactComponent };